import { render, staticRenderFns } from "./DataExport.vue?vue&type=template&id=3c7a91fa&scoped=true"
import script from "./DataExport.vue?vue&type=script&lang=js"
export * from "./DataExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7a91fa",
  null
  
)

export default component.exports